import { Input } from "../../components/input/Input";

interface DateInputProps {
  value: Date;
  onChange: (value: Date) => void;
  label?: string;
  min?: Date;
  max?: Date;
  error?: string;
}

const pad = (value: number) => String(value).padStart(2, "0");

const toDateInputValue = (date: Date) =>
  `${String(date.getFullYear()).padStart(4, "0")}-${pad(
    date.getMonth() + 1,
  )}-${pad(date.getDate())}`;

export const DateInput = (props: DateInputProps) => {
  return (
    <Input
      label={props.label}
      value={toDateInputValue(props.value)}
      onChange={(e) => {
        if (!e.target.value) return;
        const [year, month, day] = e.target.value.split("-").map(Number);
        const next = new Date(props.value);
        next.setFullYear(year, month - 1, day);
        props.onChange(next);
      }}
      type="date"
      min={props.min ? toDateInputValue(props.min) : undefined}
      max={props.max ? toDateInputValue(props.max) : undefined}
      error={props.error}
    />
  );
};
